import React, { useState } from 'react';
import { Segment, Button, Form, Header, Radio, Grid } from 'semantic-ui-react';
import questionsData from './q_pss.json';

const PSSAssessment = () => {
  // Flatten questions
  const allQuestions = questionsData.questions;

  // Initialize state
  const initialAnswers = {};
  allQuestions.forEach(q => {
    initialAnswers[q.key] = '';
  });
  const [answers, setAnswers] = useState(initialAnswers);

  const handleChange = (e, { name, value }) => setAnswers({ ...answers, [name]: value });

  // Reverse scoring for specific items (as in PSS scoring rules)
  const reverseItems = ['q4', 'q5', 'q7', 'q8']; // example for PSS-10 reverse keyed items

  const calculatePSSScore = () => {
    let totalScore = 0;
    Object.keys(answers).forEach(key => {
      const val = parseInt(answers[key]);
      if (!isNaN(val)) {
        if (reverseItems.includes(key)) {
          // Reverse scoring: 0 → 4, 1 → 3, 2 → 2, 3 → 1, 4 → 0
          totalScore += 4 - val;
        } else {
          totalScore += val;
        }
      }
    });
    return totalScore;
  };

  const handleSubmit = () => {
    const totalScore = calculatePSSScore();
    let stressLevel = '';
    if (totalScore <= 13) stressLevel = 'Low Stress';
    else if (totalScore <= 26) stressLevel = 'Moderate Stress';
    else stressLevel = 'High Stress';

    console.log("PSS Total Score:", totalScore);
    alert(`PSS Assessment Submitted!\nTotal Score: ${totalScore}\nStress Level: ${stressLevel}`);
  };

  return (
    <Segment basic style={{ padding: '15em 2em', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Grid centered>
        <Grid.Row>
          <Header as="h2" textAlign="center">PSS - Perceived Stress Scale</Header>
        </Grid.Row>
        <Grid.Row>
          <Form style={{
            width: '100%',
            maxWidth: '800px',
            margin: '0 auto',
            backgroundColor: 'white',
            padding: '2em',
            borderRadius: '10px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            {allQuestions.map(q => (
              <Form.Field key={q.key} style={{ marginBottom: '1.5em', textAlign: 'left' }}>
                <label style={{ fontWeight: 'bold', fontSize: '18px' }}>{q.q}</label>
                <Form.Group grouped style={{ marginTop: '0.5em' }}>
                  {q.options.map((opt, i) => (
                    <Form.Field key={i} style={{ display: 'block', marginTop: '0.25em' }}>
                      <Radio
                        label={opt}
                        name={q.key}
                        value={i.toString()}
                        checked={answers[q.key] === i.toString()}
                        onChange={handleChange}
                        style={{ fontSize: '18px' }}
                      />
                    </Form.Field>
                  ))}
                </Form.Group>
              </Form.Field>
            ))}

            <Button color='blue' onClick={handleSubmit} style={{ marginTop: '2em' }}>
              Submit Assessment
            </Button>
          </Form>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default PSSAssessment;
